import React, { Fragment } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import EstruturaProdutoComponent from './EstruturaProdutoComponent';

const EstruturaProdutos = () => {

  return (
    <Fragment>
      <Breadcrumbs parent="Cadastros" title="EstruturaProduto" mainTitle="Listagem de EstruturaProdutos" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <EstruturaProdutoComponent />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );

};

export default EstruturaProdutos;